"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _getStyle = _interopRequireDefault(require("get-style"));
// @ts-check

/**
 * @typedef {import("./type").MaybeHTMLElement} MaybeHTMLElement 
 */
/**
 * @param {HTMLElement} node
 * @returns {MaybeHTMLElement}
 */
var isFixed = function isFixed(node) {
  if (!document.body.contains(node)) {
    console.warn(["Dom not exists in body", node]);
    return false;
  }
  /**
   * @type any
   */
  var thisParent = node;
  while (thisParent.nodeName != "BODY") {
    var position = (0, _getStyle["default"])(thisParent, "position");
    if ("fixed" === position) {
      return thisParent;
    }
    thisParent = thisParent.parentNode;
  }
  return false;
};
var _default = exports["default"] = isFixed;
module.exports = exports.default;